import { useLang } from "@/context/LanguageContext";
import { tr } from "@/lib/translations";
import { richText } from "@/lib/richText";
import { useTextVars, applyVars } from "@/lib/textVars";

const HEADING_CLS = {
  h1: "text-4xl sm:text-5xl lg:text-6xl", h2: "text-4xl md:text-5xl", h3: "text-2xl md:text-3xl", h4: "text-xl md:text-2xl", h5: "text-lg md:text-xl",
};

/** Eigener Block auf der Startseite (Admin → Design → Startseite): alleinstehender Titel (kind „heading“, H1–H5) oder Textfeld (Fließtext, halber Abschnittsabstand). */
export const HomeTextBlock = ({ block }) => {
  const { lang } = useLang();
  const vars = useTextVars();
  const heading = block.kind === "heading";
  const title = heading ? applyVars(tr(block.title, lang), vars) : "", text = heading ? "" : applyVars(tr(block.text, lang), vars);
  if (!title && !text) return null;
  const Tag = HEADING_CLS[block.heading_level] ? block.heading_level : "h2";
  return (
    <section className={`max-w-7xl mx-auto px-6 lg:px-10 ${title ? "home-section-heading" : "home-section-half"}`} data-testid={`home-text-${block.id}`}>
      {title && <Tag className={`font-serif text-stone-900 ${HEADING_CLS[Tag]}`} data-testid={`home-text-${block.id}-title`}>{title}</Tag>}
      {text && <div className="text-base text-stone-700 leading-relaxed whitespace-pre-line">{richText(text)}</div>}
    </section>
  );
};
